export default __webpack_public_path__ + "static/media/JAS0170.34I-43643_-26080_0.cc94e2b1.jpg";